import { FC, useRef, useState } from "react";
import { Sling as Hamburger } from 'hamburger-react';
import './navbar.css';
import { AiOutlineMail, AiOutlinePoweroff } from 'react-icons/ai';
import { TieredMenu } from "primereact/tieredmenu";
import { MenuItem } from "primereact/menuitem";
import { Button } from "primereact/button";
import { MdPermIdentity } from 'react-icons/md';
import { SlOrganization } from 'react-icons/sl';

export const Navbar: FC<any> = (props): JSX.Element => {
    const { visible, setVisible, title } = props;

    // Datos mock del usuario
    const state = {
        name: "LIS Data Solutions",
        username: "example@lisdatasolutions.com",
        rol: "Administrador"
    };

    const renderName = () => {
        const names = state.name.split(" ");
        const firstInitial = names[0][0];
        const lastInitial = names[names.length - 1][0];
        return `${firstInitial}${lastInitial}`;
    };

    const menu: any = useRef<any>(null);
    const items: MenuItem[] = [
        {
            label: state.name,
            icon: <MdPermIdentity style={{ marginRight: '1rem' }} />,
            disabled: true,
        },
        {
            label: state.username,
            icon: <AiOutlineMail style={{ marginRight: '1rem' }} />,
            disabled: true,
        },
        {
            label: state.rol,
            icon: <SlOrganization style={{ marginRight: '1rem' }} />,
            disabled: true,
        },
        {
            separator: true
        },
        {
            label: 'Cerrar Sesión',
            icon: <AiOutlinePoweroff style={{ marginRight: '1rem' }} />,
            // command: handleLogout (opcional)
        }
    ];

    return (
        <div className="navbar-wrapper">
            <Hamburger toggled={visible} toggle={setVisible} size={24} color={'#343a40'} />
            <span className="navbar-title">{title}</span>

            <div className="navbar-auth">
                <div>
                    <span>{state.username}</span>
                </div>

                <div className="card flex justify-content-center">
                    <TieredMenu model={items} popup ref={menu} breakpoint="767px" className="navbar__tiered-menu" />
                    <Button className="auth-avatar settings-button" onClick={(e) => menu.current.toggle(e)}>
                        {renderName()}
                    </Button>
                </div>
            </div>
        </div>
    );
};
